import { Card, Typography } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { IMPORTABLE_MODELS } from "@/features/Import/constants";

const ExportCard = ({ activeModel, children }) => {
  const { t } = useTranslation();
  const { Title } = Typography;

  const exportTitle = t("importTool:export.title", {
    model: t(`global:${activeModel}Plural`),
  });

  return (
    <Card title={exportTitle}>
      <Title level={5}>{t("importTool:export.filters")}</Title>
      {children}
    </Card>
  );
};

ExportCard.propTypes = {
  activeModel: PropTypes.oneOf(IMPORTABLE_MODELS).isRequired,
  children: PropTypes.node,
};

export default ExportCard;
